var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"main-wrapper"},[_c('h2',[_vm._v("To login press ")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("LOGIN")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }